<template>
  <div class="d-flex" :class="{'fd-row-reverse' : isOwnMessage}">
    <pro-avatar v-if="isOwnMessage" :size="40" :image="profileImage" class="flex-0-0 m-t-1"/>
    <avatar
        v-else
        :name=message.sender_full_name
        :size="35"
        class="flex-0-0 m-t-1"
        selenium="message-avatar"/>
    <div
        class="MESSAGE"
        selenium="message"
        :class="{ 'OWN': isOwnMessage, 'SYSTEM': isSystemMessage }">
      <transition :name="transitionDirection" mode="out-in" appear>
        <div
            class="BUBBLE"
            selenium="message-bubble"
            :class="{ 'OWN': isOwnMessage, 'SYSTEM': isSystemMessage }">
          <span v-if="message.message" :class="{ 'm-b-1': hasImages }">{{ message.message }}</span>
          <gallery v-if="hasImages" :files="messageAsset" />
        </div>
      </transition>
      <span class="text-md c-gray60">{{ timeCreated  }}</span>
    </div>
  </div>
</template>

<script>

import http from '@homeservices/api-kit/axios';
import { mapGetters } from 'vuex';
import files from '@/mixins/job/files';
import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';
import { format, isToday } from 'date-fns';

export default {
  name: 'message-bubble',
  mixins: [
    files,
  ],
  props: {
    message: Object,
    isSeen: Boolean,
  },
  computed: {
    ...mapGetters('user', [
      'userId',
      'profileImage',
    ]),

    // Used by files mixin.
    fileIds () {
      return this.message.asset_urls;
    },
    hasImages () {
      return this.message.asset_urls && this.message.asset_urls.length;
    },
    isSystemMessage () {
      return this.message.message_type === 'system';
    },
    isOwnMessage () {
      return !this.isSystemMessage && this.userId === this.message.sender_id;
    },
    transitionDirection () {
      if (this.isSystemMessage) {
        return 'NONE';
      }

      return this.isOwnMessage ? 'SCALE-RIGHT' : 'SCALE-LEFT';
    },
    messageAsset () {
      return this.message.asset_urls.map(url => ({ url }));
    },
    timeCreated () {
      const created = new Date(addUTCTimeZoneDesignator(this.message.time_created));
      return isToday(created) ? `Today, ${format(created, 'p')}` : format(created, 'MMM, dd p');
    },
  },
  mounted () {
    if (!this.message.time_read && this.message.sender_type === 'consumer') {
      this.markMessageAsSeen();
    }
  },
  methods: {
    async markMessageAsSeen () {
      try {
        await http.post(`/platform/workorder/r/workorder/prorders/messages/order-hash/${this.message.order_hash}/message-id/${this.message.message_id}/actions/see/v1`);
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
    },
  },

};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .MESSAGE {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 2*$unit;
    padding: $unit 7*$unit $unit 0;
    backface-visibility: hidden;

    &.OWN {
      align-items: flex-end;
      margin-left: 0;
      margin-right: 2*$unit;
      padding-right: 0;
      padding-left: 7*$unit;
    }

    &.SYSTEM {
      align-items: center;
      margin: 0;
      padding-left: 2*$unit;
      padding-right: 2*$unit;
    }
  }

  .BUBBLE {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: $unit;
    color: $color-gray70;
    background-color: $color-gray20;
    border-radius: 2px;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-break: break-word;

    &:before {
      content: '';
      @include absolute(auto, auto, auto, -1*$unit);
      width: $unit;
      height: $unit;
      border-right: 1.5*$unit solid $color-gray20;
      border-top: 1.5*$unit solid transparent;
      border-bottom: 1.5*$unit solid transparent;

    }

    &.OWN {
      color: white;
      background-color: #286FAD;

      &:before {
        left: auto;
        right: -1*$unit;
        border-right:none;
        border-left: 1.5*$unit solid #286FAD;
      }
    }

    &.SYSTEM {
      @include text-medium;
      text-align: center;
      padding: 0;
      color: $color-gray60;
      background: none;
      border-radius: 0;

      &:before {
        display: none;
      }
    }
  }

  .SCALE-RIGHT-enter-active,
  .SCALE-RIGHT-leave-active,
  .SCALE-LEFT-enter-active,
  .SCALE-LEFT-leave-active {
    transform: none;
    will-change: transform;
    transform-origin: top right;
    transition: transform $transition-half-duration;

    &.SCALE-RIGHT-enter,
    &.SCALE-RIGHT-leave-to,
    &.SCALE-LEFT-enter,
    &.SCALE-LEFT-leave-to {
      transform: scale(0);
    }
  }

  .SCALE-LEFT-enter-active,
  .SCALE-LEFT-leave-active {
    transform-origin: top left;
  }
  .ICON  {
    margin-top: $unit;
    @include mobile-only () {
      margin-top: auto;
      margin-bottom: auto;
    }
    @include square(40px);
  }
</style>
